var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layout-wrap mx-auto",
      style: [_vm.viewActive === "laptop" ? { paddingLeft: "30px" } : ""]
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: [
            _vm.viewActive === "laptop"
              ? "w-100 justify-content-center"
              : "w-75 justify-content-center"
          ]
        },
        [
          _c(
            "div",
            { staticClass: "preview-option" },
            _vm._l(_vm.views, function(view) {
              return _c(
                "div",
                {
                  key: view.id,
                  staticClass: "preview",
                  class: { active: view.id === _vm.viewActive },
                  on: {
                    click: function($event) {
                      _vm.changeLayout(view.id)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/app-manager/icon/" +
                        view.id +
                        ".svg")
                    }
                  })
                ]
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _vm.viewActive === "laptop"
        ? _c("div", { staticClass: "card-layout" }, [
            _c("div", { staticClass: "dummy-navbar" }),
            _vm._v(" "),
            _c("div", { staticClass: "wrap-content-web" }, [
              _c(
                "div",
                { staticClass: "sidebar-web", attrs: { id: "sidebar-web" } },
                [
                  _c(
                    "div",
                    [
                      _vm.isLoadingSidebar ? _c("skeleton-sidebar") : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingSidebar
                        ? _c("sidebar-menu", {
                            ref: "sidebarMenu",
                            attrs: {
                              menus: _vm.listPages,
                              "is-parent": true,
                              "page-selected": _vm.selectedPage,
                              "icon-options": _vm.iconOptions,
                              "list-pages": _vm.listPages
                            },
                            on: {
                              "selected-page": _vm.changeSelectedPage,
                              "close-create-page": _vm.closeCreatePage,
                              "save-page": _vm.savePage,
                              "update-page": _vm.updatePage,
                              "delete-page": _vm.deletePage,
                              "reload-pages": _vm.getPagesList
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoadingSidebar
                        ? _c(
                            "div",
                            {
                              staticClass: "add-page",
                              attrs: { id: "createPage" },
                              on: { click: _vm.openCreatePage }
                            },
                            [
                              _c("span", [_vm._v("+")]),
                              _vm._v("\n            Add Menu\n          ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isLoadingSidebar
                    ? _c(
                        "b-popover",
                        {
                          ref: "createPage",
                          attrs: {
                            target: "createPage",
                            triggers: "manual",
                            placement: "bottom",
                            container: "sidebar-web"
                          }
                        },
                        [
                          _c("h3", [_vm._v("Add Menu")]),
                          _vm._v(" "),
                          _c("j-form-page", {
                            ref: "formPage",
                            attrs: {
                              "is-popover": true,
                              "icon-options": _vm.iconOptions
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-end mt-3" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "button-border mr-2",
                                  on: { click: _vm.closeCreatePage }
                                },
                                [_vm._v("\n              Close\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "button-blue",
                                  on: { click: _vm.createPage }
                                },
                                [_vm._v("\n              Save\n            ")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-web" },
                [
                  _vm.isLoading
                    ? _c("j-skeleton-component")
                    : _c(
                        "div",
                        {
                          staticClass: "section-component",
                          class: {
                            "have-data":
                              _vm.listComponent && _vm.listComponent.length > 0
                          }
                        },
                        [
                          _vm.listComponent.length === 0
                            ? _c("h5", [
                                _vm._v(
                                  "No component on this page, drag here for add component"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showConfigPage
                            ? _c(
                                "draggable",
                                {
                                  attrs: {
                                    options: {
                                      animation: 300,
                                      disabled: _vm.componentSelected
                                    },
                                    group: "componentLibrary"
                                  },
                                  on: { change: _vm.modifyData },
                                  model: {
                                    value: _vm.listComponent,
                                    callback: function($$v) {
                                      _vm.listComponent = $$v
                                    },
                                    expression: "listComponent"
                                  }
                                },
                                _vm._l(_vm.listComponent, function(
                                  component,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: component.id,
                                      staticClass: "component-list",
                                      class: {
                                        selected:
                                          _vm.componentIndexSelected === index,
                                        canvas: component.type === "canvas"
                                      }
                                    },
                                    [
                                      component.type === "form_ui" ||
                                      component.type === "multiple_form_ui"
                                        ? [
                                            component.info &&
                                            JSON.parse(component.info)
                                              .default_view === "table_view"
                                              ? _c("dummy-table-view", {
                                                  attrs: {
                                                    "data-component": component
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "table_requester_view"
                                              ? _c("dummy-table-view", {
                                                  attrs: {
                                                    "data-component": component,
                                                    type: "requestor"
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "table_approver_view"
                                              ? _c("dummy-table-view", {
                                                  attrs: {
                                                    "data-component": component,
                                                    type: "approver"
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "create_view"
                                              ? _c("dummy-create-detail-view", {
                                                  attrs: {
                                                    "data-component": component,
                                                    type: "create"
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "detail_view"
                                              ? _c("dummy-create-detail-view", {
                                                  attrs: {
                                                    "data-component": component,
                                                    type: "detail"
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "calendar_view"
                                              ? _c("dummy-calendar-view", {
                                                  attrs: {
                                                    "data-component": component
                                                  }
                                                })
                                              : component.info &&
                                                JSON.parse(component.info)
                                                  .default_view ===
                                                  "export_view"
                                              ? _c("dummy-export-view", {
                                                  attrs: {
                                                    "data-component": component
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        : component.type === "html"
                                        ? _c("dummy-html", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "canvas"
                                        ? _c("dummy-canvas", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "attendance_my_log"
                                        ? _c("dummy-attendance-my-log", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type ===
                                          "attendance_monitor"
                                        ? _c("dummy-attendance-monitor", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "attendance_report"
                                        ? _c("dummy-attendance-report", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "attendance_config"
                                        ? _c("dummy-attendance-config", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type ===
                                            "co_attendance_requestor" ||
                                          component.type ===
                                            "co_attendance_approver"
                                        ? _c("dummy-co-attendance", {
                                            attrs: {
                                              "data-component": component,
                                              type:
                                                component.type ===
                                                "co_attendance_requestor"
                                                  ? "requestor"
                                                  : "approver"
                                            }
                                          })
                                        : component.type ===
                                            "leave_requestor" ||
                                          component.type === "leave_approver" ||
                                          component.type === "leave_monitor"
                                        ? _c("dummy-leave", {
                                            attrs: {
                                              "data-component": component,
                                              type: component.type.split("_")[1]
                                            }
                                          })
                                        : component.type === "leave_config"
                                        ? _c("dummy-leave-config", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "leave_report"
                                        ? _c("dummy-leave-report", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "overtime_config"
                                        ? _c("dummy-overtime-config", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type ===
                                            "overtime_requestor" ||
                                          component.type ===
                                            "overtime_approver" ||
                                          component.type === "overtime_monitor"
                                        ? _c("dummy-overtime", {
                                            attrs: {
                                              "data-component": component,
                                              type: component.type.split("_")[1]
                                            }
                                          })
                                        : component.type === "overtime_report"
                                        ? _c("dummy-overtime-report", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "timesheet_config"
                                        ? _c("dummy-timesheet-config", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "timesheet_report"
                                        ? _c("dummy-timesheet-report", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type ===
                                          "timesheet_approval"
                                        ? _c("dummy-timesheet-approval", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "employee_setup"
                                        ? _c("dummy-employee-setup", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "user_setup"
                                        ? _c("dummy-user-setup", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "access_management"
                                        ? _c("dummy-access-management", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "embed_url"
                                        ? _c("dummy-embed-url", {
                                            attrs: {
                                              "data-component": component
                                            }
                                          })
                                        : component.type === "hierarchy" ||
                                          component.type === "custom_hierarchy"
                                        ? _c("dummy-hierarchy", {
                                            attrs: {
                                              "data-component": component,
                                              "is-custom":
                                                component.type ===
                                                "custom_hierarchy"
                                            }
                                          })
                                        : _c(
                                            "div",
                                            { staticClass: "pt-4" },
                                            [
                                              _c("j-skeleton-component", {
                                                attrs: { length: 1 }
                                              })
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "opentab-or-config" },
                                        [
                                          _c("div", { staticClass: "button" }, [
                                            component.type === "form_ui" ||
                                            component.type ===
                                              "multiple_form_ui" ||
                                            component.type === "canvas"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "open-tab",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onOpenNewtab(
                                                          component
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/automation/open-tab.svg"),
                                                        width: "16"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tooltip-component"
                                                      },
                                                      [_vm._v("Open new tab")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "config",
                                                on: {
                                                  click: function($event) {
                                                    _vm.onEditComponent(
                                                      component,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("@/assets/automation/config.svg"),
                                                    width: "16"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tooltip-component"
                                                  },
                                                  [_vm._v("Configuration")]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            : _vm._e()
                        ],
                        1
                      )
                ],
                1
              )
            ])
          ])
        : _vm.viewActive === "mobile"
        ? _c("j-layout-tab-mobile", {
            attrs: {
              "list-pages": _vm.listPages,
              "page-selected": _vm.selectedPage
            },
            on: { "selected-page": _vm.changeSelectedPage }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.componentSelected
        ? _c("jComponentProperties", {
            attrs: {
              id: _vm.idComponentProperties,
              "data-master": _vm.masterComponent,
              "data-component": _vm.componentSelected,
              "data-edit": _vm.dataEditComponent,
              "pages-id": _vm.selectedPage.id
            },
            on: {
              "delete-component": _vm.onDeleteComponent,
              "close-configuration": function($event) {
                _vm.togglePropertiesComponent(false)
              },
              "refresh-component": _vm.getListComponentByPage
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b97d143e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b97d143e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/jLayoutTab.vue
// module id = null
// module chunks = 